if(!customElements.get('collection-sort')) {
  class CollectionSort extends HTMLElement {
    constructor() {
      super();
      // Internal Elements
      this.opener = this.querySelector('p');
      this.ul = this.querySelector('ul');
      this.links = this.querySelectorAll('a');
      this.current = this.querySelector('.js-current-sort');
      // External Elements
      this.collectionGrid = document.querySelector('collection-grid');
      this.filtersFooter = document.querySelector('.js-filters-footer');
    }

    initOpener() {
      this.opener.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        this.classList.toggle('is-open');
      });
    }

    initLinks() {
      this.links.forEach(link => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          this.classList.remove('is-open');

          this.collectionGrid.applySort(link.dataset.value);

          document.querySelectorAll("collection-sort").forEach((sort) => {
            sort.setCurrentSort(link.innerText);
          });
        });
      });
    }

    setCurrentSort(value) {
      if(!this.current || !value) return;

      this.current.innerHTML = value;
      if(!this.filtersFooter) return;
      if(this.filtersFooter.updateApplyButton) this.filtersFooter.updateApplyButton(true);
    }

    connectedCallback() {
      if(!this.opener || !this.ul || !this.links.length) return;

      this.initOpener();
      this.initLinks();

      document.body.addEventListener('click', () => {
        this.classList.remove('is-open');
      });

      const currentSelectValue = this.dataset.currentSort;
      const currentSelectElement = this.querySelector(`[data-value="${currentSelectValue}"]`);
      this.setCurrentSort(currentSelectElement ? currentSelectElement.innerHTML : this.dataset.select);
    }
  }

  customElements.define('collection-sort', CollectionSort);
}
